import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { RoomCategories } from "../../configs";
import { AppDetails } from "../../configs";

interface RoomCategorySelectorProps {
  selectedCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

function RoomCategorySelector({
  selectedCategory,
  onCategoryChange,
}: RoomCategorySelectorProps) {
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onCategoryChange(newValue);
  };

  const colors = AppDetails.color;

  return (
    <Box className="room-category-sticky w-full sticky top-20 z-[70] bg-primary-main/95 backdrop-blur-sm border-y border-secondary-medium/20 shadow-md transition-opacity duration-200">
      <Tabs
        value={selectedCategory}
        onChange={handleChange}
        variant="fullWidth"
        className="!bg-primary-main"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: colors.secondaryMain,
          },
          "& .MuiTab-root": {
            color: colors.secondaryMain,
            fontWeight: 600,
            "&:hover": {
              backgroundColor: `${colors.secondaryMain}1A`, // 10% opacity
            },
            "&.Mui-selected": {
              backgroundColor: colors.secondaryDark,
              color: colors.primaryMain,
            },
          },
        }}
      >
        {RoomCategories.map((category) => (
          <Tab key={category.id} label={category.name} value={category.id} />
        ))}
      </Tabs>
    </Box>
  );
}

export default RoomCategorySelector;
